/**
 * 拼单购物车门店信息，地址信息
 */
import React, { Fragment, useEffect } from 'react'
import { observer } from 'mobx-react'
import { storeMobx } from 'restaurant'
import { buyTogetherMobx, multiPersonMobx } from '@mobxStore'
import { Icon } from '@cps'
import './index.scss'

const BtStoreInfo: React.FC = () => {
  const { info: storeInfo } = storeMobx

  useEffect(() => {
    buyTogetherMobx.eatType === 'delivery' && multiPersonMobx.setCurrentPersonAddress(buyTogetherMobx.addressInfo)
  }, [buyTogetherMobx.addressInfo])

  const handleClick = () => {
    buyTogetherMobx.selectAddress()
  }

  return (
    <div className='btcart-store-container'>
      {
        buyTogetherMobx.eatType === 'delivery' ? (
          <Fragment key='btcart-store'>
            <div className='store-wrapper'>
              <Icon name='mendian1' />
              <div className='store-wrap'>
                <div className='store-name'>{storeInfo.storeName}</div>
                {!storeInfo.inSale && (
                  <div className='store-count-down'>
                    <span className='rest-tag'>{i18n.t('store.resting')}</span>
                  </div>
                )}
              </div>
              <div className='arrow-icon'>
                <Icon name='jiantou' />
              </div>
            </div>
            <div className='address-wrapper'>
              <Icon name='mubiao' />
              <div className='address-store-wrap'>
                <div className='address-name-wrap'>
                  <span className='address-name'>{buyTogetherMobx.addressInfo?.address}{buyTogetherMobx.addressInfo?.addressDetail}</span>
                </div>
                <div className='address-location'>
                  <span>
                    <span>{buyTogetherMobx.addressInfo?.realName}</span>
                    <span>{buyTogetherMobx.addressInfo?.mobile}</span>
                  </span>
                </div>
              </div>
              {
                multiPersonMobx.getCurrentPersonInfo().isOwner && (
                  <div className='change-icon' data-cypid='bt-cart-change-address' onClick={handleClick}>
                    <Icon name='change' />
                  </div>
                )
              }
            </div>
          </Fragment>
        ) : (
          <div className='pickup-wrapper'>
            <div className='pickup-wrap'>
              <div className='title'>{i18n.t('menu.buyTogether.pickupStore')}</div>
            </div>
            <div className='address-wrapper'>
              <Icon name='mendian1' />
              <div className='address-store-wrap'>
                <div className='address-name-wrap'>
                  <span className='address-name'>{storeInfo.storeName}</span>
                </div>
                {!storeInfo.inSale && (
                  <div className='store-count-down'>
                    <span className='rest-tag'>{i18n.t('store.resting')}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        )
      }
    </div>
  )
}

export default observer(BtStoreInfo)
